import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { useTranslate } from '@gameday/utils/hooks/useTranslate';

import { Wrapper, ErrorText, StartButton, ErrorHeading } from './AutoPlayError.style';

const AutoPlayError = ({ videoRef }) => {
    const startButtonHandlers = useMemo(() => ({
        onClick: () => {
            videoRef.current.play();
        }
    }), [videoRef]);
    const translate = useTranslate();
    const noAutoPlayText = translate('message_dfv_autoplay',
        'This feature has been disabled based on the device’s power mode or the Autoplay Video setting in the MLB app.'
    );
    const startButtonLabel = translate('button_start', 'Start');
    const errorHeading = translate('message_dfv_feature_disabled', 'Feature Disabled');

    return (
        <Wrapper>
            <ErrorHeading>{errorHeading}</ErrorHeading>
            <ErrorText>{noAutoPlayText}</ErrorText>
            <StartButton label={startButtonLabel} handlers={startButtonHandlers} />
        </Wrapper>
    );
};

AutoPlayError.propTypes = {
    videoRef: PropTypes.object
};

export default AutoPlayError;
